import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { baseURL } from '../config';
import AuthContext from '../Context/AuthContext';
import AssemblyForm from '../Components/AssemblyForm';

function AssemblyAdd() {
    const navigate = useNavigate();
    const { token, logout } = useContext(AuthContext);
    const [savingAssembly, setSavingAssembly] = useState(false);
    const [assemblyTypeOptions, setAssemblyTypeOptions] = useState([]);

    useEffect(() => {
        const fetchAssemblyTypes = async () => {
            try {
                const response = await axios.get(`${baseURL}/template/getAssemblyTypes`, {
                    headers: { 'ngrok-skip-browser-warning': 'any', 'x-access-token': token },
                });
                setAssemblyTypeOptions(response.data.data);
            } catch (error) {
                if (error.response?.status === 401) logout();
            }
        };
        fetchAssemblyTypes();
    }, [token, logout]);

    const handleSave = async (payload) => {
        try {
            setSavingAssembly(true);
            const response = await axios.post(`${baseURL}/assembly/addAssembly`, payload, {
                headers: { 'ngrok-skip-browser-warning': 'any', 'x-access-token': token },
            });
            if (response.status === 201) {
                return response.data.data._id;
            }
            return null;
        } catch (error) {
            setSavingAssembly(false);
            if (error.response?.status === 401) {
                logout();
            } else if (error.response?.status === 409) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong, assembly not created');
            }
            return null;
        }
    };

    const handleSaved = () => {
        setSavingAssembly(false);
        toast.success('Assembly created successfully');
        navigate('/');
    };

    return (
        <AssemblyForm
            editAssembly={false}
            savingAssembly={savingAssembly}
            fetchingAssemblyData={false}
            onSave={handleSave}
            onSaved={handleSaved}
            assemblyTypeOptions={assemblyTypeOptions}
        />
    );
}

export default AssemblyAdd;
